import React from 'react'

export default function AdminFooter() {
  return (
    <div className='bg-light p-2'>
     <div className=' mt-3 text-center'>
             
              <p className='text-center'>© {new Date().getFullYear()}  <span className='fw-bold'> XtraGrow Foundation, Inc.</span>  |
                <a href="https://www.bighostindia.in/" style={{ color: 'black', textDecoration: 'none' }}> Design By : BigHost India Private Limited</a> </p>
            </div>
    </div>
  )
}
